import type { ReasoningTraceV1 } from '../../reasoning-trace.v1';
import type { AskDeclaredExhibitDto } from './declared-exhibit';
import type {
  AskHelixGetConversationResponseDto,
  AskHelixMessageDto,
  AskHelixQueryResponseDto,
} from '../../ask-helix';

/** Display-only copy of the final public answer. No execution or resume authority. */
export const ASK_HELIX_SAVED_PUBLIC_ANSWER_FIELDS = [
  'reasoningTrace', 'declaredExhibit',
  'answerMarkdown', 'narrationVerifications', 'numericBindings', 'executiveAnswer', 'evidence', 'assumptions', 'gaps',
  'followUps', 'truncated', 'interrupted', 'scenarioSets', 'decisionPackage',
  'metricSeries', 'rows', 'recommendations', 'turnOutcome',
  'narrationReasonCode', 'conversationStateCode',
  'executionTurnId', 'executionRunId',
  'rankedBreakdowns', 'waterfalls', 'rangeBars', 'phasedBurdens',
] as const;

// These four public-wire blocks currently have no shared producer DTO. Keep
// their named slots opaque; existing browser readers own their shape checks.
type AskHelixSavedPublicChartBlocks = {
  rankedBreakdowns?: readonly Record<string, unknown>[];
  waterfalls?: readonly Record<string, unknown>[];
  rangeBars?: readonly Record<string, unknown>[];
  phasedBurdens?: readonly Record<string, unknown>[];
};
type AskHelixSavedPublicReasoning = {
  reasoningTrace?: ReasoningTraceV1;
  declaredExhibit?: AskDeclaredExhibitDto;
};
export type AskHelixSavedPublicAnswerDto = Pick<
  AskHelixQueryResponseDto & AskHelixSavedPublicChartBlocks & AskHelixSavedPublicReasoning,
  (typeof ASK_HELIX_SAVED_PUBLIC_ANSWER_FIELDS)[number]
>;

export type AskHelixSavedMessageDto = AskHelixMessageDto & {
  publicAnswer?: AskHelixSavedPublicAnswerDto;
};

export type AskHelixGetSavedConversationResponseDto = Omit<
  AskHelixGetConversationResponseDto,
  'messages'
> & { messages: AskHelixSavedMessageDto[] };
